import {
  FOLLOWABLE_ID,
  FOLLOWABLE_TYPE,
  REACTIONABLE_ID,
  REACTIONABLE_TYPE,
  RESULTS_TYPE
} from 'dpl/constants/query_params';
import { addToQuery, parseQueryString } from 'dpl/util/queryString';

const PERSISTED_PARAMS = [
  FOLLOWABLE_TYPE,
  FOLLOWABLE_ID,
  REACTIONABLE_TYPE,
  REACTIONABLE_ID,
  RESULTS_TYPE
];

export default function buildAuthRedirectUrl() {
  const base = `${window.location.origin}${window.location.pathname}`;
  const params = parseQueryString(window.location.hash);

  const persisted = PERSISTED_PARAMS.reduce((acc, key) => {
    if (params[key] != null) acc[key] = params[key];
    return acc;
  }, {});

  if (Object.keys(persisted).length === 0) return base;

  return `${base}${window.location.search}#${addToQuery(persisted, '')}`;
}
